import React from 'react';
import './ProgressBar.css';

function ProgressBar({ steps, currentStep }) {
  return (
    <div className="progress-bar-container">
      {steps.map((step, index) => (
        <React.Fragment key={step}>
          <div className={`progress-step ${index <= currentStep ? 'active' : ''}`}>
            <div className="progress-step-circle">{index + 1}</div>
            <div className="progress-step-label">{step}</div>
          </div>
          {index < steps.length - 1 && (
            <div className={`progress-connector ${index < currentStep ? 'active' : ''}`}></div>
          )}
        </React.Fragment>
      ))}
    </div>
  );
}

export default ProgressBar;
